import '@/icons/Cloud.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueTouch from 'vue-touch'
import store from './store'
import { getExportPollingQueue } from '@/pages/H5/Cloud/views/exportPolling'
// Eagerly initialize the singleton so leader election and queue restore run on every page load.
try {
    getExportPollingQueue();
} catch (e) {
    console.error('[ExportQueue] init failed', e);
}
import {
    InfiniteScroll,
    Tooltip,
    Loading,
    Scrollbar,
    Dropdown,
    Input,
    DatePicker,
    Button,
    DropdownMenu,
    DropdownItem,
    Toast,
    Message,
    Dialog,
    Popover,
    Tree,
    Tag,
    Checkbox,
    Drawer,
    Switch
} from '@moore/moore-pc-toca'
import previewMedium from 'previewMedium'
import '@moore/moore-pc-toca/lib/theme-chalk/toast.css'
import '@moore/moore-pc-toca/lib/theme-chalk/index.css'
import CollapseTransition from '@moore/moore-pc-toca/src/transitions/collapse-transition'
import Vconsole from 'vconsole'
import 'toca-bridge'
import { tqKit } from "@flightfe/tqkit";
import { getCurrentQuery } from '@/utils';
import Tci18nVue2, { useI18n } from 'tci18n-vue2';
import * as Sentry from "@sentry/vue";
import { version, dependencies } from '../../../../package.json';
import Cookies from 'js-cookie';
import { getLang } from '../../../utils/lang'

const { source = '' } = getCurrentQuery();

const language = getLang();

Vue.use(Tci18nVue2, {
    locale: language,
    langs: __tci18n_langs__
});

store.dispatch('setCloudI18n', language);

Vue.config.productionTip = false
Vue.prototype.$toast = Toast
Vue.use(InfiniteScroll)
Vue.use(previewMedium)
Vue.use(Loading)
Vue.use(Scrollbar)
Vue.use(Dropdown)
Vue.use(Button)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Input)
Vue.use(Tag)
Vue.use(Dialog)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Tree)
Vue.use(Checkbox)
Vue.use(Drawer)
Vue.use(Switch)

try {
    const environment = process.env.VUE_APP_STATIC_NODE_ENV || 'development';
    const sentryParam = {
        Vue,
        dsn: 'https://9fbf90916e12a7639c20793cbe721a27@rum.17u.cn/226',
        tracesSampleRate: 1.0,
        release: version,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: environment,
        maxBreadcrumbs: 0,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                maxReplayDuration: 10 * 60 * 1000,
            }),
            Sentry.browserTracingIntegration(),
            Sentry.captureConsoleIntegration({ levels: ['error'] }),
        ],
        // beforeSend仅对error有效
        beforeSend(event, hint) {
            if (event.request && event.request.url) {
                try {
                    const urlObj = new URL(event.request.url);
                    const fid = urlObj.searchParams.get('fid');
                    event.tags = event.tags || {};
                    event.tags[`custom_tag_fid`] = fid;
                } catch (e) {
                    // 忽略解析错误
                }
            }
            return event;
        }
    };

    Sentry.init(sentryParam);

    const userId = Cookies.get("userId") || "";
    const token = Cookies.get("token") || "";
    const deviceId = Cookies.get("deviceId") || "";
    const spaceId = Cookies.get("spaceId") || "";
    const userInfo = {
        userId,
        token,
        deviceId,
        spaceId
    };
    Sentry.setUser(userInfo);
    if (userId) Sentry.setTag("custom_tag_userId", userId);
    const tocaEdit = dependencies['@toca/toca-edit'];
    const editorVersionMatch = String(tocaEdit).match(/toca-edit-(\d+\.\d+\.\d+)\.tgz/);
    Sentry.setTag("custom_tag_editorVersion", editorVersionMatch ? editorVersionMatch[1] : 'unknown');

    if (window.tocaSentryStartTimeStamp) {
        // sentry的事物只会生效一次
        window.tocaSentryService.tocaEditorLoadStartTransaction = Sentry.startInactiveSpan({
            name: "云文档首屏加载时间",
            startTimestamp: window.tocaSentryStartTimeStamp / 1000,
            forceTransaction: true,
            attributes: {
                href: window.location.href,
            }
        });
    }
} catch (e) {
    console.error('init Sentry error', e);
}

Vue.prototype.$message = Message

// const options = {
// 	domain: process.env.VUE_APP_UPLOAD, // 接口域名
// 	debug: false, // 是否调试模式, 将打印大量信息
// 	maxWorkers: 1,  // 最大同时允许几个任务
// }

const tqEnv = {
    'qa': 'devtools',
    'production': 'production',
    'stage': 'stage'
}
if (process.env.VUE_APP_STATIC_NODE_ENV !== 'development' && source !== 'wiki') {
    let tq = tqKit({
        ak: process.env.VUE_APP_TQ_KEY,
        appEnv: tqEnv[process.env.VUE_APP_STATIC_NODE_ENV],
        promiseErr: true,//Promise Error监控
        routerMonitor: true,//路由切换，重新获取当前页面的url和title，默认true，false关闭
        tryCatch: true,//默认开启try catch全局代理
        ajaxTiming: true,//默认开启ajaxTiming统计
        fetchTiming: true,//默认开启fetchTiming统计
        gError: true,//默认开启全局错误捕获
        ignoreList: [],//忽略列表，只接受数组参数，手机资源耗时数据的时候，哪些资源是不需要收集的，配置不用收集的资源的域名即可
        on: true,//一键关闭所有监控。默认true，开启所有监控
        rate: 1,//抽样比例，默认全额发送数据
    })
}

if (process.env.VUE_APP_STATIC_NODE_ENV !== 'production') {
    // // options.headers = {
    // // 	deviceType: "1",
    // // 	spaceId: "0583d",
    // // 	userId: "1639856760128819318",
    // // 	token: "f9dbb9f87fec4515a849d37d7753234a",
    // // 	deviceId: "afc68880596a4294b2ef4d69faf93aba",
    // // }
    //  请求头信息，如果存在 cookies，则可以不用传递
}

// const fileUploader = new FileUploader(options);

// Vue.prototype.$fileUploader = fileUploader

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component(Tooltip.name, Tooltip)

Vue.use(VueTouch, { name: 'v-touch' })

if (process.env.VUE_APP_STATIC_NODE_ENV === 'development') {
    Vue.use(new Vconsole())
}

//设置showtype
const localUrl = window.location.href;

let params = new URL(location.href).searchParams;
if (params.get('showtype')) {
    store.dispatch('setShowType', params.get('showtype'));
}

if (params.get('showtype') === 'kp') {
    //等待sdk传入初始化参数
    window.addEventListener('message', e => {
        console.log('子页面子页面e子页面e子页面e子页面ee', e);
        let data = e.data;
        if (data.type === 'userInfo') {
            let userInfo = data.data;
            store.dispatch('setUserInfo', userInfo);

            new Vue({
                router,
                store,
                i18n: Vue.prototype.tci18n,
                render: h => h(App)
            }).$mount('#app')
        }
    });
    window.parent.postMessage(
        {
            type: 'ready',
            data: {}
        },
        '*'
    );
} else {
    new Vue({
        router,
        store,
        i18n: Vue.prototype.tci18n,
        render: h => h(App)
    }).$mount('#app')
}
